import React, { useState } from 'react';
import {
  Bot, Shield, TrendingUp, Zap, ChevronRight, Plus,
  BarChart3, Layers, Award, Clock, AlertTriangle, Check,
  CreditCard, Activity, Users, Wallet, Search,
  DollarSign, ArrowDownUp, Lock, Eye, Gauge, FileText,
  Building2, Globe, ArrowRight, Link, Terminal, Bell
} from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

export const TIERS = {
  Sovereign:    { color: 'orange', gradient: 'from-orange-500 to-amber-500', bg: 'bg-orange-500/10', border: 'border-orange-500/20', text: 'text-orange-400' },
  Autonomous:   { color: 'blue',   gradient: 'from-blue-500 to-cyan-500',    bg: 'bg-blue-500/10',   border: 'border-blue-500/20', text: 'text-blue-400' },
  Supervised:   { color: 'purple', gradient: 'from-purple-500 to-indigo-500',bg: 'bg-purple-500/10', border: 'border-purple-500/20', text: 'text-purple-400' },
  Provisional:  { color: 'yellow', gradient: 'from-yellow-500 to-amber-500', bg: 'bg-yellow-500/10', border: 'border-yellow-500/20', text: 'text-yellow-400' },
  Restricted:   { color: 'gray',   gradient: 'from-gray-500 to-gray-600',    bg: 'bg-gray-500/10',   border: 'border-gray-500/20', text: 'text-gray-400' },
};

export const TABS = [
  { id: 'agents', label: 'Agent Registry', icon: Bot },
  { id: 'pool', label: 'Credit Marketplace', icon: Wallet },
  { id: 'escrow', label: 'Escrow', icon: Lock },
  { id: 'evaluators', label: 'Evaluators', icon: Eye },
  { id: 'revenue', label: 'Revenue', icon: DollarSign },
  { id: 'artifacts', label: 'Artifacts', icon: FileText },
  { id: 'knowledge', label: 'Knowledge', icon: Activity },
  { id: 'institutional', label: 'Institutional', icon: Building2 },
  { id: 'crosschain', label: 'Cross-Chain', icon: Globe },
  { id: 'positions', label: 'Position NFTs', icon: Layers },
  { id: 'repayment', label: 'Repayment', icon: Shield },
  { id: 'alerts', label: 'Alerts', icon: Bell },
  { id: 'sdk', label: 'Try SDK', icon: Terminal },
];

export const inputCls = "w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm font-mono focus:outline-none focus:border-blue-500/50 placeholder:text-gray-700";
export const selectCls = "w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-blue-500/50 text-gray-300";

export function CreditGauge({ score, tier }) {
  const pct = ((score - 300) / 550) * 100;
  const t = TIERS[tier] || TIERS.Restricted;
  return (
    <div className="relative w-48 h-48 mx-auto">
      <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
        <circle cx="50" cy="50" r="42" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="8" />
        <circle
          cx="50" cy="50" r="42" fill="none"
          stroke={`url(#gauge-${tier})`}
          strokeWidth="8" strokeLinecap="round"
          strokeDasharray={`${pct * 2.64} 264`}
          className="transition-all duration-1000"
        />
        <defs>
          <linearGradient id={`gauge-${tier}`}>
            <stop offset="0%" stopColor={tier === 'Sovereign' ? '#F59E0B' : tier === 'Autonomous' ? '#3B82F6' : '#8B5CF6'} />
            <stop offset="100%" stopColor={tier === 'Sovereign' ? '#EF4444' : tier === 'Autonomous' ? '#06B6D4' : '#6366F1'} />
          </linearGradient>
        </defs>
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-3xl font-mono font-bold text-white">{score}</span>
        <span className={`text-xs font-mono ${t.bg} ${t.border} border px-2 py-0.5 rounded-full mt-1 ${t.text}`}>
          {tier}
        </span>
      </div>
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, sub, color = 'blue' }) {
  return (
    <div className="bg-white/[0.02] border border-white/5 rounded-xl p-5 hover:border-white/10 transition-colors">
      <div className="flex items-center gap-3 mb-3">
        <div className={`w-9 h-9 rounded-lg bg-${color}-500/10 flex items-center justify-center`}>
          <Icon className={`w-4.5 h-4.5 text-${color}-400`} />
        </div>
        <span className="text-xs text-gray-500 uppercase tracking-wider">{label}</span>
      </div>
      <div className="text-2xl font-mono font-bold text-white">{value}</div>
      {sub && <div className="text-xs text-gray-600 mt-1">{sub}</div>}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="text-xs text-gray-500 uppercase mb-1.5 block">{label}</label>
      {children}
    </div>
  );
}

export {
  Bot, Shield, TrendingUp, Zap, ChevronRight, Plus,
  BarChart3, Layers, Award, Clock, AlertTriangle, Check,
  CreditCard, Activity, Users, Wallet, Search,
  DollarSign, ArrowDownUp, Lock, Eye, Gauge, FileText,
  Building2, Globe, ArrowRight, Link, Terminal, Bell
};
